/* globals google , MutationObserver */
(() => {
	const INSTANCES = []
	class Googletranslate {
		constructor (id, params) {
			INSTANCES.push(this)
			this.id = id
			this.params = params
			this.instaled = 0
			this.active = ''
			document.addEventListener('DOMContentLoaded', this.init.bind(this))
			if (document.readyState === 'complete') this.init()
		}

		static get INSTANCES () {
			return INSTANCES
		}
		observe () {
			let targetNode = document.querySelector('#original-google-translate')
			let config = { attributes: true, childList: true, subtree: true }
			this.observer = new MutationObserver(this.init.bind(this))
			this.observer.observe(targetNode, config)
		}

		init () {
			this.container = document.querySelector(this.id)
			this.buttonlist = this.container.querySelectorAll('button[data-lang]');
			[...this.buttonlist].forEach(button => {
				button.addEventListener('click', this.run.bind(this, button))
			})

			let activelang = this.getCurrentLang()
			if (activelang && activelang !== this.params.siteLanguage) {
				this.run(this.container.querySelectorAll('button[data-lang="' + activelang + '"]')[0]
				)
			}
		}

		run (button) {
			this.activebutton = button
			this.instaled === 0 ? this.install() : this.processTranslate()
		}

		install () {
			let scriptTag = document.createElement('script')
			scriptTag.setAttribute('src', '//translate.google.com/translate_a/element.js?cb=' + this.register())
			document.body.appendChild(scriptTag)
		}

		register () {
			let onloadCallBackFn = 'afterLoadGt'
			window[onloadCallBackFn] = this.afterInstall()
			return onloadCallBackFn
		}

		afterInstall () {
			return () => {
				this.instaled = 1
				this.google = new google.translate.TranslateElement({pageLanguage: this.params.siteLanguage, includedLanguages: this.params.language.join(','), autoDisplay: false}, 'original-google-translate')

				Array.apply(null, document.querySelectorAll('link[href="https://translate.googleapis.com/translate_static/css/translateelement.css"]')).forEach(function (node) {
					node.parentNode.removeChild(node)
				})
				document.getElementsByTagName('body')[0].classList.add('gt')
				this.processTranslate()
			}
		}

		getCurrentLang () {
			let activelang = document.cookie.match('(^|;) ?googtrans=([^;]*)(;|$)')
			return activelang ? activelang[2].split('/')[2] : null
		}

		processTranslate () {
			this.gtWidget = document.querySelector('.goog-te-combo')
			this.getLangList()
			let active = this.container.querySelectorAll('.active');
			[...active].forEach(lang => {
				lang.classList.remove('active')
			})
			let element = this.activebutton
			element.classList.add('active')
			this.selectedLang = element.getAttribute('data-lang')
			let button = this.lang[this.selectedLang]
			if (this.params.siteLanguage === element.getAttribute('data-lang')) {
				this.fireReset()
				this.prevLang = this.currentLang
				this.currentLang = element.getAttribute('data-lang')
			} else {
				this.prevLang = this.currentLang
				this.currentLang = element.getAttribute('data-lang')
				this.observeWidget()
				this.fireEvent(button)
			}
		}

		getLangList () {
			let optionlist = this.gtWidget.querySelectorAll('option')
			this.lang = {};
			[...optionlist].forEach(option => {
				this.lang[option.value] = option
			})
		}

		fireReset () {
			let reset = document.querySelector('.skiptranslate')
			let iframe = reset.querySelector('iframe')
			if (!iframe) {
				return
			}
			let item = iframe.contentDocument.querySelectorAll('button')[3]
			if (item) {
				item.click()
			}
		}

		fireEvent (button) {
			if (button) { button.selected = true }
			let newEvent = document.createEvent('HTMLEvents')
			newEvent.initEvent('change', true, true)
			this.gtWidget.dispatchEvent(newEvent)
		}

		observeWidget () {
			let targetNode = document.querySelector('#original-google-translate')
			let config = { attributes: true, childList: true, subtree: true }
			this.observerChange = new MutationObserver(this.checkWidget.bind(this))
			this.observerChange.observe(targetNode, config)
		}

		checkWidget () {
			this.getLangList()
			let button = this.lang[this.selectedLang]
			this.gtWidget = document.querySelector('.goog-te-combo')
			let optionlist = this.gtWidget.querySelectorAll('option')
			if (optionlist.length === 0) { return }

			if (!button) { return }

			if (!optionlist || this.selectedLang !== this.gtWidget.value) { setTimeout(this.fireEvent(button), 2000) } else {
				this.observerChange.disconnect()
			}
		}
	}
	if (window.Googletranslate === undefined) { window.Googletranslate = Googletranslate }
})()



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_googletranslate/script.js